/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import ClickableDiv from 'components/Common/ClickableDiv';
import FormLabel from 'components/pages/ResourceSetting/Widgets/FormLabel';
import FormBox from 'components/pages/ResourceSetting/Widgets/FormBox';
import classNames from 'classnames';
import Styles from './index.module.css';

export default function TextButtonField({
  title,
  description,
  buttonText,
  value,
  onClick,
  disabled,
  required,
  maxLength,
  singleLine,
  squat,
  className,
  ...props
}) {
  return (
    <ClickableDiv
      onClick={onClick}
      className={classNames(Styles.mainContainer, className)}
      {...props}
    >
      <FormLabel
        title={title}
        description={description}
        disabled={disabled}
        required={required}
      />
      <div className={Styles.inputArea}>
        <div style={{ flex: 3, marginRight: 18, minWidth: 0 }}>
          <FormBox
            style={{
              fontSize: 14,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'left',
            }}
          >
            {value}
          </FormBox>
        </div>
        <div className={Styles.uploadButton}>{buttonText}</div>
      </div>
    </ClickableDiv>
  );
}

TextButtonField.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  buttonText: PropTypes.string,
  value: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  maxLength: PropTypes.number,
  singleLine: PropTypes.bool,
  squat: PropTypes.bool,
  className: PropTypes.string,
};

TextButtonField.defaultProps = {
  title: '',
  description: '',
  buttonText: '',
  value: '',
  onClick: () => {},
  disabled: false,
  required: false,
  maxLength: -1,
  singleLine: false,
  squat: false,
  className: '',
};
